import apiClient from '../../authentication/utils/core/axios';

const MarketSnapshotAPI = {
  // Fixed: Added fetchAll method that combines all market overview data
  fetchAll: async () => {
    const [topMovers, topGainers, topLosers, mostActive] = await Promise.all([
      apiClient.get('/market-overview/top-movers'),
      apiClient.get('/market-overview/top-gainers'),
      apiClient.get('/market-overview/top-losers'),
      apiClient.get('/market-overview/most-active')
    ]);
    
    return {
      topMovers: topMovers.data,
      topGainers: topGainers.data,
      topLosers: topLosers.data,
      mostActive: mostActive.data
    };
  },
  
  fetchTopMovers: async () => {
    const res = await apiClient.get('/market-overview/top-movers');
    return res.data;
  },
  
  fetchTopGainers: async () => {
    const res = await apiClient.get('/market-overview/top-gainers');
    return res.data;
  },
  
  fetchTopLosers: async () => {
    const res = await apiClient.get('/market-overview/top-losers');
    return res.data;
  },
  
  fetchMostActive: async () => {
    const res = await apiClient.get('/market-overview/most-active');
    return res.data;
  },
  
  fetchSingleSnapshot: async (symbol) => {
    const res = await apiClient.get(`/market-snapshot/${symbol}`);
    return res.data;
  },

fetchBatchSnapshots: async (symbols) => {
  // symbols: array of strings, e.g. ['AAPL', 'TSLA']
  const params = { symbols: symbols.join(",") };  // Convert array to comma-separated string
  const res = await apiClient.get('/market-snapshots/batch', { params });
  return res.data;
},
};

export default MarketSnapshotAPI;